<template>
  <div>
    <h4 class="workplatform-title m-t-10 m-b-10">合同基本信息</h4>
    <Row>
      <i-col span="8">
        <label class="title text-title-65">合同编号</label>{{ contractInfo.code }}
        <a class="m-l-5" @click="showContractDetail"><Icon type="md-search" />查看合同详情</a>
      </i-col>
      <i-col span="8">
        <span class="title text-title-65">合同名称</span>{{ contractInfo.name }}
      </i-col>
      <i-col span="8">
        <span class="title text-title-65">客户名称</span>{{ contractInfo.advertiserName }}
        <template v-if="contractInfo.secondParty">
          <Tag v-if="contractInfo.secondParty.partyType===10" color="green">企业</Tag>
          <Tag v-else color="cyan">个人</Tag>
        </template>
      </i-col>
    </Row>
    <Row class="p-b-5">
      <i-col span="8">
        <span class="title text-title-65">开始日期</span>{{ contractInfo.startDate }}
      </i-col>
      <i-col span="8">
        <span class="title text-title-65">结束日期</span>{{ contractInfo.endDate }}
      </i-col>
      <i-col span="8">
        <span class="title text-title-65">用途</span>{{ contractInfo.rentTypeName }}
      </i-col>
    </Row>
    <Row class="p-b-5">
      <i-col span="8">
        <span class="title text-title-65">创建人</span>{{ contractInfo.createUserName }}
      </i-col>
      <i-col span="8">
        <span class="title text-title-65">创建时间</span>{{ contractInfo.createTime }}
      </i-col>
    </Row>
    <Row>
      <i-col span="24">
        <span class="title text-title-65">附加条款</span>{{ contractInfo.description }}
      </i-col>
    </Row>

    <h4 class="workplatform-title m-t-10 m-b-10">账单明细</h4>
    <Row class="m-b-5">
      <i-col flex="500px">
        <DatePicker type="date" v-model="query.startDate" @on-change="handleSearch" size="small" placeholder="选择账单开始日期" clearable style="width: 200px"></DatePicker>
        <DatePicker type="date" v-model="query.endDate" @on-change="handleSearch" size="small" class="m-l-10" placeholder="选择账单结束日期" clearable style="width: 200px"></DatePicker>
      </i-col>
      <i-col flex="auto">
        <RadioGroup v-model="selectedGroup" @on-change="handleSearch" type="button" size="small" button-style="solid">
            <Radio v-for="(item,index) in billGroupArray" :key="index" :label="item"></Radio>
        </RadioGroup>
      </i-col>
    </Row>
    <Alert>
      <p>
        全部账单总额：{{ formatMoney(statistics.total) }}
      </p>
      <p v-for="(item,index) in statistics.groupArray" :key="index" class="m-t-5">
        {{ item.assetName }}<Divider type="vertical" />
        <span v-for="(ele,index2) in item.data" :key="index2" class="m-r-10">
          {{ ele.feeTypeName }}：{{ formatMoney(ele.amount) }}
        </span>
      </p>
      <template v-if="query.startDate||query.endDate">
        <Divider style="margin: 10px 0;"/>
        <p>
          当前查询日期内账单总额：{{ formatMoney(statisticsByCondition.total) }}
        </p>
        <p v-for="(item,index) in statisticsByCondition.groupArray" :key="'condi'+index" class="m-t-5">
          {{ item.assetName }}<Divider type="vertical" />
          <span v-for="(ele,index2) in item.data" :key="index2" class="m-r-10">
            {{ ele.feeTypeName }}：{{ formatMoney(ele.amount) }}
          </span>
        </p>
      </template>
    </Alert>
    <Table size="small" stripe :data="tableData" :loading="tableLoading" :columns="tableColumns"></Table>
    <div class="paging_style">
        <Page size="small" show-total show-elevator :current="query.pageNumber" :page-size="query.pageSize" :total="total" @on-change="handlePageNumberChange"></Page>
    </div>

    <Modal v-model="modalShowContractDetail" title="合同详情" footer-hide width="1200">
      <contractDetail ref="contractDetail"/>
    </Modal>
  </div>
</template>

<script>
import contractDetail from '@/components/investmentContract/modalComponents/detail.vue'

import { toMoney } from '@/utils/wnumb_own'
import { listDetailByContract } from '@/api/invest/debt'
import { getContractInfo } from '@/api/invest/contract'
import { formatDebtStatus } from '@/utils/tagStatus'

export default {
  props: {},
  components: {
    contractDetail
  },
  data () {
    return {
      contractInfo: {},
      billGroupArray: null,
      selectedGroup: null,

      modalShowContractDetail: false,
      query: {
        pageNumber: 1,
        pageSize: 15,
        startDate: '',
        endDate: ''
      },

      tableLoading: false,
      total: 0,
      baseTableData: [],
      showTableData: [],
      tableData: [],
      tableColumns: [
        { title: '标的物名称', key: 'objectName' },
        { title: '所属资产', key: 'assetName' },
        { title: '所在站点', key: 'stationName' },
        { title: '开始日期', key: 'startDate' },
        { title: '结束日期', key: 'endDate' },
        { title: '费用类型', key: 'feeTypeName' },
        {
          title: '账单金额',
          key: 'amount',
          render: (h, params) => {
            return h('strong', {
              attrs: {
                style: 'color:#44bd32'
              }
            },
            toMoney(params.row.amount))
          }
        },
        {
          title: '账单状态',
          width: 100,
          align: 'center',
          render: (h, params) => {
            return formatDebtStatus(
              h,
              params.row.status,
              params.row.statusName
            )
          }
        }
      ],

      statistics: {
        total: 0,
        groupArray: []
      },
      statisticsByCondition: {
        total: 0,
        groupArray: []
      }
    }
  },
  mounted () {},
  created () {
    if (this.contractId) {
      this.initDetail()
    }
  },
  methods: {
    initDetail () {
      this.tableLoading = true
      // 载入账单信息
      listDetailByContract({ contractId: this.contractId }).then(res => {
        this.baseTableData = res
        this.tableLoading = false

        const group = ['全部']
        const groupAsset = []
        this.statistics = {
          total: 0,
          groupArray: []
        }
        res.forEach(element => {
          if (!groupAsset.includes(element.assetName)) {
            groupAsset.push(element.assetName)
          }
          if (!group.includes(element.feeTypeName)) {
            group.push(element.feeTypeName)
          }
          // 统计账单总额
          this.statistics.total += element.amount
        })

        // 开始计算线路数据
        let assetData = []
        let curAssetDataByFeeType = null
        let assetDataByFeeType = []

        groupAsset.forEach(element => {
          assetDataByFeeType = []
          assetData = this.baseTableData.filter(x => x.assetName === element)

          assetData.forEach(assetItem => {
            curAssetDataByFeeType = assetDataByFeeType.find(x => x.feeTypeName === assetItem.feeTypeName)
            if (curAssetDataByFeeType) {
              curAssetDataByFeeType.amount += assetItem.amount
            } else {
              assetDataByFeeType.push({
                feeTypeName: assetItem.feeTypeName,
                amount: assetItem.amount
              })
            }
          })

          this.statistics.groupArray.push({
            assetName: element,
            data: assetDataByFeeType
          })
        })

        this.billGroupArray = group
        this.selectedGroup = group[0]

        this.handleSearch()
      })

      // 载入合同信息
      getContractInfo({ contractId: this.contractId }).then(res => {
        this.contractInfo = res
      })
    },
    handleSearch () {
      if (this.selectedGroup === '全部') {
        this.showTableData = this.baseTableData
      } else {
        this.showTableData = this.baseTableData.filter(x => x.feeTypeName === this.selectedGroup)
      }

      if (this.query.startDate) {
        this.showTableData = this.showTableData.filter(x => new Date(x.startDate) > this.query.startDate)
      }
      if (this.query.endDate) {
        let formatEndDate = new Date(this.query.endDate)
        formatEndDate = formatEndDate.setDate(formatEndDate.getDate() + 1)

        this.showTableData = this.showTableData.filter(x => new Date(x.endDate) < formatEndDate)
      }

      this.total = this.showTableData.length
      this.getStatisticsData()
      this.handlePageNumberChange(1)
    },
    getStatisticsData () {
      if (!this.query.startDate && !this.query.endDate) { return }

      this.statisticsByCondition = {
        total: 0,
        groupArray: []
      }

      const groupAsset = []
      this.showTableData.forEach(element => {
        if (!groupAsset.includes(element.assetName)) {
          groupAsset.push(element.assetName)
        }
        // 统计查询条件内的账单总额
        this.statisticsByCondition.total += element.amount
      })

      // 开始计算线路数据
      let assetData = []
      let curAssetDataByFeeType = null
      let assetDataByFeeType = []

      groupAsset.forEach(element => {
        assetDataByFeeType = []
        assetData = this.showTableData.filter(x => x.assetName === element)

        assetData.forEach(assetItem => {
          curAssetDataByFeeType = assetDataByFeeType.find(x => x.feeTypeName === assetItem.feeTypeName)
          if (curAssetDataByFeeType) {
            curAssetDataByFeeType.amount += assetItem.amount
          } else {
            assetDataByFeeType.push({
              feeTypeName: assetItem.feeTypeName,
              amount: assetItem.amount
            })
          }
        })

        this.statisticsByCondition.groupArray.push({
          assetName: element,
          data: assetDataByFeeType
        })
      })

      // this.showTableData.forEach(element => {
      //   if (!this.statisticsByCondition.groupArray.find(x => x.group === element.feeTypeName)) {
      //     this.statisticsByCondition.groupArray.push({
      //       group: element.feeTypeName,
      //       value: element.amount
      //     })
      //   } else {
      //     this.statisticsByCondition.groupArray.find(x => x.group === element.feeTypeName).value += element.amount
      //   }

      //   this.statisticsByCondition.total += element.amount
      // })
    },
    formatMoney (number) {
      return toMoney(number)
    },
    showContractDetail () {
      this.modalShowContractDetail = true
      this.$refs.contractDetail.initBaseData(this.contractId)
    },
    handlePageNumberChange (page) {
      this.query.pageNumber = page
      const startRow = (this.query.pageNumber - 1) * this.query.pageSize
      const getRows = startRow + this.query.pageSize
      const pageData = []

      for (let index = startRow; index < getRows; index++) {
        if (index < this.showTableData.length) {
          pageData.push(this.showTableData[index])
        }
      }
      this.tableData = pageData
    }
  },
  watch: {
    contractId () {
      this.initDetail()
    }
  },
  computed: {
    contractId () {
      return this.$store.state.investmentDebt.contractId
    }
  }
}
</script>
